export default "__VITE_ASSET__DchaDeFF__"